import React, { createContext, useContext, useMemo } from 'react';

const NavUiContext = createContext({
  openMobileNav: () => {},
  expandSidebar: () => {},
  isMobile: false,
  isSidebarCollapsed: false,
});

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {() => void} props.openMobileNav
 * @param {() => void} props.expandSidebar
 * @param {boolean} props.isMobile
 * @param {boolean} props.isSidebarCollapsed
 */
export function NavUiProvider({
  children,
  openMobileNav,
  expandSidebar,
  isMobile,
  isSidebarCollapsed,
}) {
  const value = useMemo(
    () => ({
      openMobileNav,
      expandSidebar,
      isMobile,
      isSidebarCollapsed,
    }),
    [openMobileNav, expandSidebar, isMobile, isSidebarCollapsed]
  );

  return <NavUiContext.Provider value={value}>{children}</NavUiContext.Provider>;
}

/**
 * @returns {{
 *   openMobileNav: () => void,
 *   expandSidebar: () => void,
 *   isMobile: boolean,
 *   isSidebarCollapsed: boolean,
 * }}
 */
export function useNavUi() {
  return useContext(NavUiContext);
}

export default NavUiContext;
